module.exports = "/images/shoppingCart_light.jpg";